function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import Layout from '@4c/layout';
import styled from 'astroturf';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import Button from './Button';
const messages = defineMessages({
  toggle: {
    "id": "@bfly/ui:toggleButton",
    "defaultMessage": "Toggle drawer open"
  }
});
const Bar = /*#__PURE__*/styled('div', null, {
  displayName: "Bar",
  styles: require("./ToggleButton-Bar.module.scss"),
  attrs: null,
  vars: []
});

function ToggleButton(props) {
  const {
    formatMessage
  } = useIntl();
  return React.createElement(Button, _extends({}, props, {
    theme: "link",
    "aria-label": formatMessage(messages.toggle)
  }), React.createElement(Layout, {
    direction: "column"
  }, React.createElement(Bar, null), React.createElement(Bar, null), React.createElement(Bar, null)));
}

export default ToggleButton;